module.exports = __webpack_public_path__ + "img/frank.d9bd5efa.png";